import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Tenant } from '../api'
import { Settings } from 'lucide-react'

interface TenantSettingsTabProps {
  tenant: Tenant
}

export function TenantSettingsTab({ tenant }: TenantSettingsTabProps) {
  return (
    <div className="space-y-6">
      {/* Metadata */}
      <Card>
        <CardHeader>
          <CardTitle>Tenant Information</CardTitle>
          <CardDescription>Tenant details and timestamps</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">Name</span>
            <span className="text-sm text-muted-foreground">
              {tenant.name}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">Display Name</span>
            <span className="text-sm text-muted-foreground">
              {tenant.displayName}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">Created At</span>
            <span className="text-sm text-muted-foreground">
              {new Date(tenant.createdAt).toLocaleString()}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">Updated At</span>
            <span className="text-sm text-muted-foreground">
              {new Date(tenant.updatedAt).toLocaleString()}
            </span>
          </div>
        </CardContent>
      </Card>

      {/* Future Settings Placeholder */}
      {/* <Card>
        <CardHeader>
          <CardTitle>Settings</CardTitle>
          <CardDescription>Tenant configuration options</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8">
            <Settings className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">Coming Soon</h3>
            <p className="text-muted-foreground">
              Tenant settings and configuration will be available in a future update.
            </p>
          </div>
        </CardContent>
      </Card> */}
    </div>
  )
}
